/**
 * Required for data normalization
 * @param {string} value
 * @returns {string}
 */
const removeExtraCharacters = (value: string): string =>
  value.replace(/[+()\-_ ]+/g, '');

export default removeExtraCharacters;
